import { BANNERS_ACTION_TYPES, BANNERS_CONFIG } from './actionTypes';
import { bannersApi } from './api';

export const bannersActions = {
    fetchListRequest: () => ({
        type: BANNERS_ACTION_TYPES.FETCH_LIST_REQUEST,
    }),

    fetchListSuccess: (data, total, totalPages) => ({
        type: BANNERS_ACTION_TYPES.FETCH_LIST_SUCCESS,
        payload: { data, total, totalPages },
        meta: { timestamp: Date.now() },
    }),

    fetchListFailure: (error) => ({
        type: BANNERS_ACTION_TYPES.FETCH_LIST_FAILURE,
        payload: { error },
        error: true,
    }),
}

export const fetchBannersList = (options = {}) => {
    return async (dispatch, getState) => {
        const { per_page = BANNERS_CONFIG.DEFAULT_PAGE_SIZE, refresh = false } = options;
        const state = getState().banners;

        if (state && state.loading && state.loading.list && !refresh) {
            return;
        }

        dispatch(bannersActions.fetchListRequest());

        try {
            const result = await bannersApi.fetchList({
                per_page,
            });

            dispatch(bannersActions.fetchListSuccess(
                result.data,
                result.total,
                result.totalPages
            ));
        } catch (error) {
            console.error('Banners fetch error:', error);
            dispatch(bannersActions.fetchListFailure(error.message));
        }
    }
}
